import type { StrategyNode } from '../types/BaseNode';
import { serializeNode } from './serializeNode';

export function getSavedStrategies(): { name: string; data: any }[] {
  return JSON.parse(localStorage.getItem('moneymaker_strategies') || '[]');
}

export function deleteSavedStrategy(nameToDelete: string) {
  const existing = JSON.parse(localStorage.getItem('moneymaker_strategies') || '[]');
  const filtered = existing.filter((s: any) => s.name !== nameToDelete);
  localStorage.setItem('moneymaker_strategies', JSON.stringify(filtered));
}

export function saveStrategy(name: string, node: StrategyNode, start: string = '', end: string = '') {
  node.title = name;
  const serialized = serializeNode(node, start, end);
  const existing = JSON.parse(localStorage.getItem('moneymaker_strategies') || '[]');

  const updated = [...existing, { name, data: serialized }];
  localStorage.setItem('moneymaker_strategies', JSON.stringify(updated));
}